// extracted by mini-css-extract-plugin
export var icon = "_9e-3";
export var subtitle = "_9e-2";
export var title = "_9e-1";
export var value = "_9e-0";